<template>
  <v-app>
    <v-main>
      <event-schedule :widgetId="widgetId" />
    </v-main>
  </v-app>
</template>

<script>
import EventSchedule from "./components/EventSchedule";

export default {
  components: {
    EventSchedule,
  },
  props: ["widgetId"],
  name: "App",
};
</script>
